import { Component, Input, OnInit } from '@angular/core';
import { CONFIG } from '../../../../config';

@Component({
    selector: 'rms-filter-chip-legend',
    templateUrl: './filter-chip-legend.component.html',
    styleUrls: ['./filter-chip-legend.component.scss'],
    standalone: false
})
export class FilterChipLegendComponent implements OnInit {

  @Input() legends: Array<{ color: string, label: string}> = [];

  public tooltipOpenDelay = CONFIG.tooltipOpenDelay;

  constructor() { }

  ngOnInit() { }

}
